import {apiPost} from './api';

export default class ServicioCertificados {
  static reporteEnvio(filtros) {
    return apiPost('/certificados/Enviar/Reporte', filtros);
  }

  static obtenerCertificado(muestraID) {
    const data = {
      Muestra: {
        MuestraID: muestraID,
      },
    };
    return apiPost('/certificados/Obtener', data);
  }

  static autorizarMuestras(muestras) {
    const data = {
      Muestras: muestras,
    };
    return apiPost('/certificados/Autorizar', data);
  }

  static enviarCertificados(muestras) {
    const data = {
      Muestras: muestras,
    };
    return apiPost('/certificados/Enviar', data);
  }

  static consultaAutorizaciones(filtros) {
    return apiPost('/certificados/Autorizar/Reporte', filtros);
  }

  static desAutorizar(muestras) {
    const data = {
      Muestras: muestras,
    };
    return apiPost('/certificados/Desautorizar', data);
  }
}
